import { Lightning, Utils } from '@lightningjs/sdk';
import { Buttons } from '../../Business/player/ui/OverlayHelper';
import { Theme } from '../../config/theme';

const Constants = {
  Rewind: {
    x: 764,
    y: 80,
  },
  Play: {
    x: 886,
    y: 80,
  },
  Pause: {
    x: 880,
    y: 80,
  },
  Forward: {
    x: 992,
    y: 80,
  },
  Settings: {
    x: 1104,
    y: 80,
  },
};

export class PlayerButtonRow extends Lightning.Component {
  static _template() {
    return {
      Rewind: {
        type: Lightning.Component,
        x: Constants.Rewind.x,
        y: Constants.Rewind.y,
        mountY: 0.5,
        src: Utils.asset('images/player/fast-rewind.png'),
      },
      Play: {
        type: Lightning.Component,
        x: Constants.Play.x,
        y: Constants.Play.y,
        mountY: 0.5,
        src: Utils.asset('images/player/play-icon.png'),
        visible: false,
      },
      Pause: {
        type: Lightning.Component,
        x: Constants.Pause.x,
        y: Constants.Pause.y,
        mountY: 0.5,
        src: Utils.asset('images/player/pause-icon.png'),
        visible: false,
      },
      Forward: {
        type: Lightning.Component,
        x: Constants.Forward.x,
        y: Constants.Forward.y,
        mountY: 0.5,
        src: Utils.asset('images/player/fast-forward.png'),
      },
      Settings: {
        type: Lightning.Component,
        x: Constants.Settings.x,
        y: Constants.Settings.y,
        mountY: 0.5,
        src: Utils.asset('images/player/settings.png'),
      },
    };
  }

  /**
   * @param {PlayerController} playerController
   */
  init(playerController) {
    this._playerController = playerController;
    this._playerController.uiEventHandlers.updateControlButtons = this.updateEnabledButtons.bind(this);
    this._availableButtons = [Buttons.REWIND, Buttons.PLAY, Buttons.PAUSE, Buttons.FORWARD, Buttons.SETTINGS];
    this._playerController.controlsManager.setInitialButtonConfig(false);
    this._showPlayPause(this._enabledButtons.includes(Buttons.PLAY));
    this._buttonIndex = 0;
    this.setDisabledButtons();
    this.changeVisualFocus();
  }

  _focus() {
    this._setButtonIndex(true);
    this.changeVisualFocus();
  }

  _setButtonIndex(reset = false) {
    if (reset || this._buttonIndex < 0) {
      let bIndex = this._enabledButtons.findIndex(b => b === Buttons.PLAY || b === Buttons.PAUSE);
      if (bIndex < 0) {
        bIndex = this._enabledButtons.findIndex(b => b === Buttons.SETTINGS);
      }
      this._buttonIndex = bIndex;
    }
  }

  _unfocus() {
    if (this._buttonIndex >= 0) {
      this.tag(this._enabledButtons[this._buttonIndex]).color = Theme.Colors.Player.Controls.Buttons.Default;
    }
  }

  _getFocused() {
    if (this._enabledButtons.length > 0 && this._buttonIndex >= 0) {
      return this.tag(this._enabledButtons[this._buttonIndex]);
    } else {
      return this;
    }
  }

  changeVisualFocus(focussed = true) {
    if (focussed) {
      this._enabledButtons.forEach((val, i) => {
        if (i === this._buttonIndex) {
          this.tag(val).color = Theme.Colors.Player.Controls.Buttons.Focus;
        } else {
          this.tag(val).color = Theme.Colors.Player.Controls.Buttons.Default;
        }
      });
    } else {
      this._enabledButtons.forEach(val => {
        this.tag(val).color = Theme.Colors.Player.Controls.Buttons.Default;
      });
    }
  }

  setDisabledButtons() {
    this._availableButtons.forEach(b => {
      if (!this._enabledButtons.includes(b)) {
        this.tag(b).color = Theme.Colors.Player.Controls.Buttons.Disabled;
      }
    });
  }

  /**
   * @param {string[]} buttons
   */
  updateEnabledButtons(buttons) {
    this._enabledButtons = buttons;
    this._showPlayPause(buttons.includes(Buttons.PLAY));
    this._setButtonIndex();
    if (this.hasFocus()) {
      this.changeVisualFocus(true);
    } else {
      this.changeVisualFocus(false);
    }
    this.setDisabledButtons();
  }

  _showPlayPause(playEnabled) {
    if (playEnabled) {
      this.tag(Buttons.PLAY).visible = true;
      this.tag(Buttons.PAUSE).visible = false;
    } else {
      this.tag(Buttons.PLAY).visible = false;
      this.tag(Buttons.PAUSE).visible = true;
    }
  }

  _handleLeft() {
    if (this._buttonIndex > 0) {
      this._buttonIndex -= 1;
      this.changeVisualFocus();
    }
    return false;
  }

  _handleRight() {
    if (this._buttonIndex < this._enabledButtons.length - 1) {
      this._buttonIndex += 1;
      this.changeVisualFocus();
    }
    return false;
  }

  _handleEnter() {
    const activated = this._enabledButtons[this._buttonIndex];
    return this._playerController.controlsManager.handleActivateButton(activated, this);
  }
}
